import { paths } from '../../../../../common/constants/pathVariables';
import { omaElisaForCompaniesMsg, orderConfirmationsMsg, t } from '../../../../../common/i18n';
import { MessageCenter } from '../../../../../components/MessageCenter/MessageCenter';
import { OrderConfirmations } from '../../../../../components/MessageCenter/OrderConfirmations';

export const OrderConfirmationsPath = () => {
  return (
    <MessageCenter
      breadCrumbs={[
        { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
        { name: t.I86M(orderConfirmationsMsg) },
      ]}
    >
      <OrderConfirmations />
    </MessageCenter>
  );
};
